module.exports = __webpack_public_path__ + "letterFadePositionInTop.gif";